import { BaseClass } from '../base-class';
import { BaseRepository } from '@interfaces/base-repository';
import { HolidayGroup } from './holiday-group';

export class Holiday extends BaseClass {
    date: Date;
    description: string;
    group: HolidayGroup;

    constructor()
    constructor(
      date: Date,
      description: string,
      group: HolidayGroup
      )
    constructor(
      date?: Date,
      description?: string,
      group?: HolidayGroup
      ) {
        super();

        this.date = date;
        this.description = description;
        this.group = group;
    }

    static fromObject(object: Holiday): Holiday {
        return Object.assign(new Holiday(), {
          ...object,
          group: object.group ? HolidayGroup.fromObject(object.group) : null,
        });
    }
}
